import apiClient from './apiClient';

export async function getTaskForm() {
  const response = await apiClient.get('/api/task-form');
  return response.data;
}

export async function verifyTaskEmail(email) {
  const response = await apiClient.post('/api/task-applications/verify-email', { email });
  return response.data;
}

export async function submitTaskApplication({ email, responses, files }) {
  const formData = new FormData();
  formData.append('payload', JSON.stringify({ email, responses }));

  Object.entries(files || {}).forEach(([fieldKey, file]) => {
    if (file) {
      formData.append(fieldKey, file);
    }
  });

  const response = await apiClient.post('/api/task-applications', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
}
